import React from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import EmbededEntityInput from '../input/embedded_entity'
import RegionsInput from '../input/regions'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import BoolField from 'bstrap-react-mobx-admin/field/bool'
import BoolInput from 'bstrap-react-mobx-admin/input/bool'

const PricingEdit = ({ store }) => {
  const PricingEditForm = ({ store, state, record, updateFormField, errors }) => {
    const enums = new Map()
    enums.set('days', [
      { value: 'DAY' },
      { value: 'WEEK' },
      { value: 'MONTH' },
      { value: 'YEAR' }
    ])
    const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkSubentity(store, state)
    const dateRestriction = store.timeRestriction.pricings
    const isCommingSoon = (record.has('coming_soon_flag') && record.get('coming_soon_flag'))

    if (stageOneRestricted) {
      record.get('quality_mobile_price') && record.set('quality_mobile_price', parseFloat(record.get('quality_mobile_price')).toFixed(2))
      record.get('quality_sd_price') && record.set('quality_sd_price', parseFloat(record.get('quality_sd_price')).toFixed(2))
      record.get('quality_hd_price') && record.set('quality_hd_price', parseFloat(record.get('quality_hd_price')).toFixed(2))
      record.get('quality_uhd_price') && record.set('quality_uhd_price', parseFloat(record.get('quality_uhd_price')).toFixed(2))
    }

    return (
      <div className='row'>
        <div className='col-sm-12 col-lg-6'>
          <DateInput
            label={store.__('valid from')}
            attr={'valid_from'}
            record={record}
            disabled={stageOneRestricted}
            minDate={dateRestriction.valid_from.minDate}
            onChange={updateFormField}
            showTime={true}
            errors={errors} />
          <DateInput
            label={store.__('valid to')}
            attr={'valid_to'}
            disabled={stageTwoRestricted}
            minDate={dateRestriction.valid_to.minDate}
            record={record}
            onChange={updateFormField}
            showTime={true}
            validToTime={true}
            errors={errors} />
          <BoolInput label={store.__('UTC time')} disabled={stageOneRestricted}
            attr={'utc_flag'} record={record} onChange={updateFormField} errors={errors} />
          <RegionsInput label={store.__('regions')} attr={'regions'}
            record={record} onChange={updateFormField} tzInfo={true}
            errors={errors} disabled={stageOneRestricted}
            optionsrecord={store.options} optionsattr={'Countries'} />
          <SelectInput
            label={store.__('currency')}
            attr={'currency_cd'}
            record={record}
            labelattr='text'
            valueattr='value'
            onChange={updateFormField}
            optionsrecord={store.options}
            optionsattr={'ContractCurrency'}
            errors={errors} disabled={stageOneRestricted} />
        </div>
        <div className='col-sm-12 col-lg-6'>
          <fieldset disabled={stageOneRestricted}>
            <TextInput type='number' step='any' disabled={isCommingSoon}
              label={store.__('Mobile quality price')}
              attr={'quality_mobile_price'}
              record={record}
              onChange={updateFormField}
              errors={errors} />
            <TextInput type='number' step='any' disabled={isCommingSoon}
              label={store.__('SD quality price')}
              attr={'quality_sd_price'}
              record={record}
              onChange={updateFormField}
              errors={errors} />
            <TextInput type='number' step='any' disabled={isCommingSoon}
              label={store.__('HD quality price')}
              attr={'quality_hd_price'}
              record={record}
              onChange={updateFormField}
              errors={errors} />
            <TextInput type='number' step='any' disabled={isCommingSoon}
              label={store.__('UHD quality price')}
              attr={'quality_uhd_price'}
              record={record}
              onChange={updateFormField}
              errors={errors} />
            <TextInput type='number' step='any'
              label={store.__('period length')}
              attr={'period_length'}
              record={record}
              onChange={updateFormField}
              errors={errors} />
            <SelectInput
              label={store.__('period time unit')}
              attr={'period_time_unit'}
              record={record}
              onChange={updateFormField}
              labelattr='value'
              optionsrecord={enums}
              optionsattr={'days'}
              errors={errors} />
            <BoolInput label={store.__('Coming soon')} disabled={stageOneRestricted}
              attr={'coming_soon_flag'} record={record} onChange={updateFormField} errors={errors} />
          </fieldset>
        </div>
      </div>
    )
  }

  return (
    <EmbededEntityInput
      store={store}
      helper='flyprivate_pricings/details'
      edit_title={store.__('Edit pricing details')}
      add_title={store.__('Add  pricing details')}
      label={store.__('Pricing details')}
      attr='pricings'
      errors={store.cv.errors}
      fields={[
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_to} showTime />),
        (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.valid_from} showTime />),
        (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
        (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
        (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
        (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
        (attr, row) => (<span>{row[attr] === null ? '-' : parseFloat(row[attr]).toFixed(2)}</span>),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<BoolField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />),
        (attr, row) => (<TextField attr={attr} val={row[attr]} />)
      ]}
      rowId={(row) => null}
      EditForm={PricingEditForm}
    />
  )
}
PricingEdit.propTypes = {
  store: PropTypes.object.isRequired
}

export default observer(PricingEdit)
